module.exports = "/_next/static/images/458bf68cba066b2de6c117ddd8f63f45-slide-3-small.png";